import './Header.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import Button from '@/common/components/atoms/Button/Button';
import Picture from '@/common/components/atoms/Picture/Picture';
import { ReactComponent as CloseIcon } from '@/ebat/assets/icons/close-circle.svg';
import logoScanbat from '@/ebat/assets/logos/scanbat.png';

import { HeaderDefaultProps, HeaderPropTypes } from './Header.proptypes';
import useHeader from './useHeader';

const Header = ({
  className,
  company,
  disabled,
  link,
  onRemoveWarehouse,
  warehouse,
}) => {
  const { t } = useTranslation();

  const { getCompanyLogo, hasCompanyLogo, setHasCompanyLogo } = useHeader({
    company,
  });

  return (
    <div className={cn('scanbat-header', className)}>
      <div className="scanbat-header__left">
        <NavLink to={link} className="scanbat-header__link">
          <img
            alt={t('ebat:messages:scanbat.title')}
            className="scanbat-header__logo"
            src={logoScanbat}
          />
        </NavLink>
        {hasCompanyLogo && getCompanyLogo && (
          <Picture
            alt={company}
            className="scanbat-header__company"
            onError={() => setHasCompanyLogo(false)}
            src={getCompanyLogo}
            type="static"
          />
        )}
      </div>
      {warehouse?.name && (
        <Button
          className="scanbat-header__warehouse"
          disabled={disabled}
          onClick={onRemoveWarehouse}
        >
          <span className="button__label">{warehouse.name}</span>
          <CloseIcon className="button__icon" />
        </Button>
      )}
    </div>
  );
};

Header.defaultProps = {
  ...HeaderDefaultProps,
};

Header.propTypes = {
  ...HeaderPropTypes,
};

export default Header;
